import { DetailedHTMLProps, InputHTMLAttributes, forwardRef } from "react";
import { cn } from "../utils/tailwind";

type BaseNumberInputProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export type NumberInputProps = Omit<BaseNumberInputProps, "type">;

export default forwardRef<HTMLInputElement, NumberInputProps>(
  function NumberInput({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        type="number"
        className={cn(
          "bg-white border border-gray-300 rounded px-4 py-2 focus:outline-hidden focus:ring-2 focus:ring-grey",
          className,
        )}
        {...props}
      />
    );
  },
);
